<template>
    <svg
    class="rp-home-icon"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="16px" height="15px">
    <path fill-rule="evenodd"
    :class="isItFullScreen? 'fullscreen' : ''"
    d="M14.000,8.000 L14.000,9.000 L14.000,15.000 L10.000,15.000 L10.000,9.000 L6.000,9.000 L6.000,15.000 L2.000,15.000 L2.000,9.000 L2.000,8.000 L-0.000,8.000 L8.000,-0.000 L16.000,8.000 L14.000,8.000 Z"/>
    </svg>
</template>
<script>
export default {
    props: {
        isItFullScreen: {
            type: Boolean,
            default: false
        }
    }
}
</script>
<style lang="scss" scoped>
.rp-home-icon {
    margin-bottom: -2px;
    path {
        fill: #000000;
        &.fullscreen {
            fill: #ffffff;
        }
    }
}
</style>
